import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4","key":"svg-0"}]]

const IconNumber5Small = createReactComponent('outline', 'number-5-small', 'Number5Small', __iconNode);

export default IconNumber5Small;